import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import cvSiadisPdf from "./files/css_cv_full.pdf";
import { useSiteCopy } from "../context/SiteCopyContext";
import { swapLocaleInPath } from "../localeConfig";

const Navbar = () => {
  const { locale } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { copy } = useSiteCopy();

  const prefix = `/${locale}`;

  const goLocale = (nextLocale) => {
    navigate(swapLocaleInPath(location.pathname, nextLocale));
  };

  return (
    <nav className="navbar-expand-md navbar fixed-top" id="navbar">
      <a className="navbar-brand" data-scroll href="#home-area">
        <a
          className="btn content-download button-main button-scheme"
          href={cvSiadisPdf}
          target="_blank"
          rel="noreferrer"
          role="button"
        >
          {copy.downloadCvLabel}
        </a>
      </a>
      <span
        className="navbar-menu ml-auto"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        role="button"
      >
        <span className="btn-line" />
      </span>
      <div
        className="collapse navbar-collapse order-1 order-lg-0"
        id="navbarSupportedContent"
      >
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <Link className="nav-link" to={prefix}>
              {copy.navHome}
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to={`${prefix}/about`}>
              {copy.navAbout}
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to={`${prefix}/resume`}>
              {copy.navResume}
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to={`${prefix}/contact`}>
              {copy.navContact}
            </Link>
          </li>
          <li className="nav-item d-flex align-items-center ml-md-2 mt-2 mt-md-0">
            <span className="nav-link py-0 d-flex align-items-center">
              <button
                type="button"
                className={`btn btn-sm ${locale === "en" ? "button-main" : "btn-outline-light"}`}
                onClick={() => goLocale("en")}
                aria-pressed={locale === "en"}
              >
                EN
              </button>
              <button
                type="button"
                className={`btn btn-sm ml-1 ${locale === "nl" ? "button-main" : "btn-outline-light"}`}
                onClick={() => goLocale("nl")}
                aria-pressed={locale === "nl"}
              >
                NL
              </button>
            </span>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
